import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CdsIconModule } from '@cds/angular';
import { ClrDatagridModule } from '@clr/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ReplacePipe } from './pipes/replace.pipe';
import { PhoneDisplayPipe } from './pipes/phone-display.pipe';
import { RecordsTableComponent } from './components/records-table/records-table.component';
import { DropzoneDirective } from './directives/dropzone.directive';
import { SprintfPipe } from './pipes/sprintf.pipe';
import { Convertor } from '../utils/convertor';

//TODO DELETE ALL THE SHARED MODULE
@NgModule({
	declarations: [SprintfPipe, DropzoneDirective, ReplacePipe, RecordsTableComponent],
	imports: [CommonModule, CdsIconModule, ClrDatagridModule, TranslateModule, RouterLink, PhoneDisplayPipe],
	exports: [
		//DIRECTIVE
		DropzoneDirective,

		//PIPE
		ReplacePipe,
		SprintfPipe,

		//COMPONENT
		RecordsTableComponent,

		//MODULE
		TranslateModule
	],
	providers: [DatePipe, Convertor]
})
export class SharedModule {}
